import { render, staticRenderFns } from "./InActive.vue?vue&type=template&id=1fb6a2ea"
import script from "./InActive.vue?vue&type=script&lang=js"
export * from "./InActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports